import { Exception } from 'app/api/exception/Exception';

/**
 * Исключение выбрасывается при отсутствии данных в справочнике.
 */
export class EmptyReferenceException extends Exception {
    static readonly NAME = 'EmptyReferenceException';

    private static readonly EMPTY_REFERENCE_DEFAULT_MESSAGE =
        'Отсутствуют данные в справочнике';

    private static readonly DEFAULT_EXCEPTION_ID = 'id';

    constructor() {
        super(
            EmptyReferenceException.DEFAULT_EXCEPTION_ID,
            EmptyReferenceException.NAME,
            EmptyReferenceException.EMPTY_REFERENCE_DEFAULT_MESSAGE,
        );

        this.name = EmptyReferenceException.NAME;
    }
}
